import { render, staticRenderFns } from "./CryptogramCell.vue?vue&type=template&id=2a8c4e62&scoped=true"
import script from "./CryptogramCell.vue?vue&type=script&lang=js"
export * from "./CryptogramCell.vue?vue&type=script&lang=js"
import style0 from "./CryptogramCell.vue?vue&type=style&index=0&id=2a8c4e62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c4e62",
  null
  
)

export default component.exports